import type { AttributionConfig } from '../types/attribution';

export const DEFAULT_ATTRIBUTION_CONFIG: AttributionConfig = {
  enabled: true,
  ttlDays: 90,
  persist: true,
  captureUrlParams: true,
  captureCookies: true,
  customClickIdParams: [],
};
